import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { allStoreProducts, buildWhatsAppOrderText, WHATSAPP_E164 } from '../catalog';
import { useCart } from '../context/CartContext';
import CartItem from './CartItem';
import ProductCard from './ProductCard';

function shufflePick(list, count) {
  const arr = [...list];
  for (let i = arr.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr.slice(0, count);
}

export default function CartPage({ setActivePage }) {
  const { cartLines } = useCart();

  const suggestedProducts = useMemo(() => {
    const inCart = new Set(cartLines.map((l) => l.productId));
    const pool = allStoreProducts.filter((p) => !inCart.has(p.id));
    const n = Math.min(4, pool.length);
    return shufflePick(pool, n);
  }, [cartLines]);

  const whatsappHref =
    cartLines.length > 0
      ? `https://wa.me/${WHATSAPP_E164}?text=${encodeURIComponent(buildWhatsAppOrderText(cartLines))}`
      : null;

  return (
    <>
      <main className="cart-page">
        <div className="cart-page-inner">
          <h1 className="cart-page-heading">Your cart</h1>

          {cartLines.length === 0 ? (
            <div className="cart-empty-state">
              <p className="cart-empty-title">Your cart is empty 🛒</p>
              <p className="cart-empty-sub">Browse pickles, powders, and spices to fill your cart.</p>
              <Link
                to="/"
                className="continue-shopping-btn"
                onClick={() => setActivePage?.('home')}
              >
                Continue shopping
              </Link>
            </div>
          ) : (
            <ul className="cart-page-list">
              {cartLines.map((line) => (
                <CartItem key={line.key} line={line} />
              ))}
            </ul>
          )}
        </div>

        {cartLines.length > 0 && suggestedProducts.length > 0 ? (
          <section className="suggested-section suggested-section--cart" aria-labelledby="suggested-heading">
            <h2 id="suggested-heading" className="suggested-heading">
              You may also like
            </h2>
            <div className="suggested-grid">
              {suggestedProducts.map((product) => (
                <ProductCard key={product.id} product={product} compact />
              ))}
            </div>
          </section>
        ) : null}

        {/* Spacer so content is not hidden behind sticky bar on mobile */}
        {cartLines.length > 0 ? <div className="cart-sticky-spacer" aria-hidden /> : null}
      </main>

      {cartLines.length > 0 ? (
        <div className="cart-checkout-sticky">
          <a className="whatsapp-order-btn whatsapp-order-btn--sticky" href={whatsappHref} target="_blank" rel="noopener noreferrer">
            Order on WhatsApp
          </a>
        </div>
      ) : null}
    </>
  );
}
